import React, { useMemo } from 'react';
import classNames from 'classnames';

const styles = require('./ProgressBar.module.scss');

type ProgressContext = 'talent' | 'company' | 'neutral';

export interface ProgressBarProps {
  className?: string;
  context?: ProgressContext;
  currentStep: number;
  label?: string;
  totalSteps: number;
}

export default function ProgressBar({
  className,
  context = 'neutral',
  currentStep,
  label = 'Progress',
  totalSteps,
}: ProgressBarProps) {
  const clampedStep = Math.max(0, Math.min(currentStep, totalSteps));

  const steps = useMemo(
    () => Array.from({ length: totalSteps }, (_, i) => i + 1),
    [totalSteps]
  );

  return (
    <div
      className={classNames(styles.container, className)}
      role="progressbar"
      aria-label={label}
      aria-valuenow={clampedStep}
      aria-valuemin={0}
      aria-valuemax={totalSteps}
    >
      {steps.map((step) => (
        <div
          key={step}
          className={classNames(styles.segment, step <= clampedStep ? styles[context] : styles.inactive)}
          aria-hidden="true"
        />
      ))}
    </div>
  );
}
